import React from 'react';
import DividerSvg from '../../../static/aim-assets/divider.svg';
import './page-divider.styles.css';

// <div className="divider-container py-10 sm:py-12 md:py-24 lg:py-32">

const AimDivider = ({ className = '', showDivider = true }) => {
  return (
    <div className="divider-container py-20 md:py-16">
      <div
        style={{ display: showDivider ? '' : 'none' }}
        className={`divider-background py-12 md:py-16 ${className}`}
      >
        <img src={DividerSvg} alt="Divider" className="divider-image w-full max-w-lg" />
      </div>
    </div>
  );
};

export default AimDivider;
